module.exports = __webpack_public_path__ + "img/analyse.5ee5cc5c.png";